<template>
  <section class="story03">
    <div class="story03--con">
      <div class="con--inner">
        <div class="story03--txt">
          <img src="@/assets/images/brandstory/logo_white_new@2x.png" class="story03--logo mb-2" alt="botalab">
          <p class="mb-2">당신의 삶을 건강하고 아름답게 자연이 우리에게 안정적인 삶을 제공하듯 <br>
          보타랩은 당신의 삶 속에 아름다움과 균형을 이룰 수 있도록 Natural Lifestyle을 추구합니다.</p>
          <p class="mb-2">
          본연의 아름다움을 전하고자 오랜시간 동안 연구된 자연의 에너지를 담았습니다.
          </p>
          <p>
          매일 시작과 끝을 함께하며, 오늘 하루도 당신의 삶을 건강하고 아름답게 변화시키는<br>
          ECO-TECH 프리미엄 퍼스널케어 브랜드,보타랩입니다.</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Section3',
};
</script>
